var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<footer class=\"FooterNav\">\n<nav>\n<ul>\n<li>\n{{ 'COMPONENT.FOOTER_NAV.COPYRIGHT' | translate }}\n</li>\n<li>\n{{ 'COMPONENT.FOOTER_NAV.ALL_RIGHTS_RESERVED' | translate }}\n</li>\n<li>\n<a href=\"https://spike.ikegps.com/last-time-buy-tc/\" target=\"_blank\">{{ 'COMPONENT.FOOTER_NAV.TERMS_CONDITIONS' | translate }}</a>\n</li>\n<li>\n<a href=\"https://www.ikegps.com/privacy-policy/\" target=\"_blank\">{{ 'COMPONENT.FOOTER_NAV.PRIVACY' | translate }}</a>\n</li>\n<li>\nVersion: {{ applicationVersion }}\n</li>\n</ul>\n</nav>\n<div class=\"FooterNav-logo\"></div>\n</footer>\n";
var id1="footer.nav.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/layout/footer/footer.nav.html
// module id = 461
// module chunks = 0